var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminCard',[_c('template',{slot:"title"},[_c('h2',[_vm._v("Baum")])]),(_vm.admin_node_tree)?_c('node-tree',{attrs:{"level":1,"node":_vm.admin_node_tree.tree}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }